import React from 'react';
import { QueryProvider } from './QueryProvider';

export const StockItemsProviders = ({ children }: any) => {
	return <QueryProvider>{children}</QueryProvider>;
};
